import { ComponentPropsWithoutRef, forwardRef } from "react";
import { Icon } from "./BellIcon.Parts";

export const BellIcon = forwardRef<
  SVGSVGElement,
  ComponentPropsWithoutRef<"svg">
>((props, ref) => (
  <Icon
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M8 20C9.1 20 10 19.0769 10 17.9487H6C6 19.0769 6.9 20 8 20ZM14 13.8462V8.71795C14 5.56923 12.37 2.93333 9.5 2.2359V1.53846C9.5 0.68718 8.83 0 8 0C7.17 0 6.5 0.68718 6.5 1.53846V2.2359C3.64 2.93333 2 5.55897 2 8.71795V13.8462L0 15.8974V16.9231H16V15.8974L14 13.8462ZM12 14.8718H4V8.71795C4 6.17436 5.51 4.10256 8 4.10256C10.49 4.10256 12 6.17436 12 8.71795V14.8718Z"
      fill="currentColor"
    />
  </Icon>
));
